import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, Grid } from 'semantic-ui-react';
import { push } from 'connected-react-router';
import { EEhsType, EUserLevels, EUserRoles, IBuilding, IEhs, IUser } from '@relab/alstom-ptw-shared';

import { HeaderComponent } from '../components/HeaderComponent';
import { RootState } from '../redux/types';
import { appState } from '../redux/selectors';
import { NavBar } from '../components/NavBar';
import { buildingsAction, ehssAction } from '../redux/actions';
import { EhssListComponent } from '../components/ehs/EhssListComponent';
import { TranslationComponent } from '../components/TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

interface EhssSceneProps extends Component {
  ehss: IEhs[];
  user: IUser;
  buildings: IBuilding[];
  ehssAction: typeof ehssAction;
  buildingsAction: typeof buildingsAction;
  push: typeof push;
  t: typeof i18n.t;
}

class PEhssScene extends Component<EhssSceneProps> {
  componentDidMount() {
    this.props.ehssAction();
    this.props.buildingsAction();
  }

  render() {
    const { ehss, push, user, t } = this.props;

    return (
      <>
        <HeaderComponent />
        <NavBar />
        <Grid>
          <Grid.Column floated="right" width={3}>
            <Dropdown text={t('New EHS')} floating button>
              <Dropdown.Menu>
                {(user.userLevel === EUserLevels.Admin ||
                  user.userRoles.some((role) => [EUserRoles.EhsApplicant, EUserRoles.EhsManager].includes(role))) && (
                  <Dropdown.Item>
                    <Button
                      primary
                      onClick={() =>
                        push({
                          pathname: '/ehss/create',
                          search: `?ehsType=${EEhsType.SITO}&userRoles=${user.userRoles}`,
                        })
                      }
                    >
                      <TranslationComponent stringKey={'New EHS Sito'} />
                    </Button>
                  </Dropdown.Item>
                )}
                {(user.userLevel === EUserLevels.Admin ||
                  user.userRoles.some((role) =>
                    [
                      EUserRoles.EhsMaintenanceBasic,
                      EUserRoles.EhsMaintenanceManager,
                      EUserRoles.EhsMaintenanceExternalCompany,
                      EUserRoles.EhsMaintenanceExternalCompanyPlus,
                    ].includes(role)
                  )) && (
                  <Dropdown.Item>
                    <Button
                      primary
                      onClick={() =>
                        push({
                          pathname: '/ehss/create',
                          search: `?ehsType=${EEhsType.MAINTENANCE}&userRoles=${user.userRoles}`,
                        })
                      }
                    >
                      <TranslationComponent stringKey={'New EHS Maintenance'} />
                    </Button>
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Grid.Column>
        </Grid>
        <EhssListComponent ehss={ehss} buildings={this.props.buildings} />
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  const { user, ehss, buildings = [] } = appState(state);
  return {
    user,
    ehss,
    buildings,
  };
};

export const EhssScene = connect(mapStateToProps, { ehssAction, buildingsAction, push })(withTranslation()(PEhssScene));
